import { useQuery } from '@tanstack/react-query'
import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'
import { RefreshablePages } from '../ContentRefresh/types'
import { DecodedValueMap, NumberParam, StringParam } from 'use-query-params'

type ReturnType = {
  data: RefreshablePages
  isLoading: boolean
  isFetching: boolean
  refetch: () => void
  error: unknown
}

const fetchDomainRefreshPages = async (
  companyId: string,
  reportId?: string,
  limit?: number,
  queryParams?: any
) => {
  try {
    const url = `${SEO_SERVICE_BASE_URL}/companies/${companyId}/content-refresh/${reportId}/pages`
    const response = await axios.get(url, {
      params: {
        limit,
        page: queryParams.page,
        sort: '(max_traffic-traffic):desc',
        'filter[page_url]': queryParams.search,
        'filter[tag]': queryParams.type,
      },
    })

    return response.data
  } catch (error) {
    return extract.error(error)
  }
}

type Args = {
  companyId: string
  isEnabled: boolean
  reportId?: string
  limit: number
  queryParams: DecodedValueMap<{
    search: typeof StringParam
    type: typeof StringParam
    page: typeof NumberParam
  }>
}

export const useGetDomainRefreshParamsPaginated = ({
  companyId,
  isEnabled = false,
  reportId,
  limit,
  queryParams,
}: Args): ReturnType => {
  const {
    data: response,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery({
    queryFn: () => {
      if (!reportId) return
      return fetchDomainRefreshPages(companyId, reportId, limit, queryParams)
    },
    queryKey: [
      'content-gap-domain-refresh-params-paginated',
      companyId,
      reportId,
      queryParams,
    ],
    enabled: isEnabled,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  })

  return {
    data: response,
    isLoading,
    isFetching,
    error,
    refetch,
  }
}
